/* eslint-disable */
import { createRouter, createWebHistory } from "vue-router";
import cookies from "vue-cookies";

const routes = [
  {
    path: "/",
    alias: ["/Register", "/R/:id", "/Admin"],
    name: "authentication",
    component: () =>
      import(
        /* webpackChunkName: "authentication" */ "../views/Authentication.vue"
      ),
    props: true,
    meta: {
      title: "تامین مالی جمعی آتیه ایرانیان | احراز هویت",
    },
  },
  {
    path: "/splus/auth",
    name: "auth",
    component: () =>
      import(/* webpackChunkName: "auth" */ "../views/AuthenticationSplus.vue"),
    props: true,
    meta: {
      title: "اس پلاس | احراز هویت",
    },
  },
  {
    path: "/splus/dashboard",
    name: "dashboardsplus",
    component: () =>
      import(
        /* webpackChunkName: "dashboardsplus" */ "../views/DashboardSplus.vue"
      ),
    props: true,
    meta: {
      title: "اس پلاس | احراز هویت",
    },
  },
  {
    path: "/Dashboard",
    name: "dashboard",
    component: () =>
      import(/* webpackChunkName: "dashboard" */ "../views/Dashboard.vue"),
    props: true,
    meta: {
      title: "تامین مالی جمعی آتیه ایرانیان | پرتال سرمایه گذاری",
    },
    children: [
      {
        path: "/Dashboard",
        name: "root",
        component: () =>
          import(/* webpackChunkName: "root" */ "../views/Root.vue"),
      },
      {
        path: "/Dashboard/Form/:entity_type",
        alias: ["/Dashboard/Form/:entity_type/:id"],
        name: "form",
        component: () =>
          import(/* webpackChunkName: "form" */ "../components/Form.vue"),
        props: true,
      },
      {
        path: "/Dashboard/List/:entity_type",
        alias: ["/Dashboard/List/:entity_type/:page/:size"],
        name: "list",
        component: () =>
          import(/* webpackChunkName: "list" */ "../components/List.vue"),
        props: true,
      },
      {
        path: "/Dashboard/Receipt/:id",
        name: "receipt",
        component: () =>
          import(/* webpackChunkName: "receipt" */ "../components/Receipt.vue"),
        props: true,
      },
      {
        path: "/Dashboard/SIP",
        name: "sip",
        component: () =>
          import(/* webpackChunkName: "sip" */ "../components/Phone/SIP.vue"),
      },
      {
        path: "/Dashboard/Ticket",
        name: "ticket",
        component: () =>
          import(/* webpackChunkName: "ticket" */ "../views/Ticket.vue"),
      },
      {
        path: "/Dashboard/Investment/Deposit",
        name: "investments",
        component: () =>
          import(
            /* webpackChunkName: "investments" */ "../views/Investments.vue"
          ),
        props: true,
      },
      {
        path: "/Dashboard/Investment/Special/Deposit",
        name: "investments_special",
        component: () =>
          import(
            /* webpackChunkName: "investments_special" */ "../views/Investments_New.vue"
          ),
        props: true,
      },
      {
        path: "/Dashboard/Offer/:status",
        name: "offers",
        component: () =>
          import(/* webpackChunkName: "offers" */ "../views/Offers.vue"),
        props: true,
      },
      {
        path: "/Dashboard/Offers/:status",
        name: "special",
        component: () =>
          import(/* webpackChunkName: "offers" */ "../views/Special.vue"),
        props: true,
      },
      {
        path: "/Dashboard/Calculator",
        name: "calculator",
        component: () =>
          import(
            /* webpackChunkName: "calculator" */ "../views/Calculator.vue"
          ),
      },
      {
        path: "/Dashboard/Inquiry/Internal",
        name: "internalinquiry",
        component: () =>
          import(
            /* webpackChunkName: "internalinquiry" */ "../views/InternalInquiry.vue"
          ),
      },
      {
        path: "/Dashboard/Inquiry/External",
        name: "externalinquiry",
        component: () =>
          import(
            /* webpackChunkName: "externalinquiry" */ "../views/ExternalInquiry.vue"
          ),
      },
      {
        path: "/Dashboard/Inquiry/External/Warranty",
        name: "warrantyinquiry",
        component: () =>
          import(
            /* webpackChunkName: "warrantyinquiry" */ "../views/WarrantyInquiry.vue"
          ),
      },
      {
        path: "/Dashboard/Inquiry/External/Sejam",
        name: "sejaminquiry",
        component: () =>
          import(
            /* webpackChunkName: "sejaminquiry" */ "../views/SejamInquiry.vue"
          ),
      },
      {
        path: "/Dashboard/Marketing",
        name: "marketing",
        component: () =>
          import(/* webpackChunkName: "marketing" */ "../views/Marketing.vue"),
      },
      {
        path: "/Dashboard/2FA",
        name: "2fa",
        component: () =>
          import(/* webpackChunkName: "2fa" */ "../views/2FA.vue"),
      },
      {
        path: "/Dashboard/Payment",
        name: "paymentorder",
        component: () =>
          import(
            /* webpackChunkName: "paymentorder" */ "../views/PaymentOrder.vue"
          ),
      },
      {
        path: "/Dashboard/Reward",
        name: "reward",
        component: () =>
          import(/* webpackChunkName: "reward" */ "../views/Reward.vue"),
      },
      {
        path: "/Dashboard/Report",
        name: "report",
        component: () =>
          import(/* webpackChunkName: "report" */ "../views/Report.vue"),
      },
      {
        path: "/Dashboard/Regulator",
        name: "regulator",
        component: () =>
          import(/* webpackChunkName: "regulator" */ "../views/Regulator.vue"),
      },
      {
        path: "/Dashboard/ProfitSync",
        name: "profitsync",
        component: () =>
          import(
            /* webpackChunkName: "profitsync" */ "../views/ProfitSync.vue"
          ),
        props: true,
        meta: {
          title: "تامین مالی جمعی آتیه ایرانیان | بارگذاری سود‌های تقسیمی",
        },
      },
      {
        path: "/Dashboard/Profile",
        name: "profile",
        component: () =>
          import(/* webpackChunkName: "profile" */ "../views/Profile.vue"),
      },
      {
        path: "/Dashboard/Project",
        name: "project",
        component: () =>
          import(/* webpackChunkName: "project" */ "../views/Project.vue"),
      },
      {
        path: "/Dashboard/Settings",
        name: "settings",
        component: () =>
          import(/* webpackChunkName: "settings" */ "../views/Settings.vue"),
      },
      {
        path: "/Dashboard/SMS",
        name: "sms",
        component: () =>
          import(/* webpackChunkName: "sms" */ "../views/SMS.vue"),
      },
      {
        path: "/Dashboard/:pathMatch(.*)*",
        name: "maintenance",
        component: () =>
          import(
            /* webpackChunkName: "maintenance" */ "../components/Maintenance.vue"
          ),
      },
    ],
  },
  {
    path: "/Dashboard/SSO",
    name: "sso",
    component: () => import(/* webpackChunkName: "sso" */ "../views/SSO.vue"),
    meta: {
      title: "تامین مالی جمعی آتیه ایرانیان | ورود سریع",
    },
  },
  {
    path: "/vc",
    redirect: "/Project/e31399be-1982-4673-b10e-09b7109706a4",
  },
  {
    path: "/Project/:id",
    component: {
      mounted() {
        window.location.href = `https://atiyehiraniancf.com/Project/${this.$route.params.id}`;
      },
      render: () => null,
    },
  },
  {
    path: "/Au",
    redirect: "/Authentication",
  },
  {
    path: "/Authentication",
    redirect: "/",
  },
  {
    path: "/s/:id",
    component: () =>
      import(/* webpackChunkName: "redirect" */ "../views/Redirect.vue"),
    props: true,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "notfound",
    component: () =>
      import(/* webpackChunkName: "notfound" */ "../components/NotFound.vue"),
    meta: {
      title: "تامین مالی جمعی آتیه ایرانیان | صفحه یافت نشد",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      const element = document.querySelector(to.hash);
      if (element) {
        return {
          el: to.hash,
          behavior: "smooth",
        };
      }
    }
    return {
      top: 0,
    };
  },
});

const urlParams = new URLSearchParams(window.location.search);

const utm_source = urlParams.get("utm_source") || cookies.get("utm_source");
const utm_medium = urlParams.get("utm_medium") || cookies.get("utm_medium");
const utm_campaign =
  urlParams.get("utm_campaign") || cookies.get("utm_campaign");
const utm_term = urlParams.get("utm_term") || cookies.get("utm_term");
const utm_content = urlParams.get("utm_content") || cookies.get("utm_content");
const referred_from =
  urlParams.get("referred_from") || cookies.get("referred_from");

if (utm_source)
  cookies.set("utm_source", utm_source, "30d", "/", ".atiyehiraniancf.com");

if (utm_medium)
  cookies.set("utm_medium", utm_medium, "30d", "/", ".atiyehiraniancf.com");

if (utm_campaign)
  cookies.set("utm_campaign", utm_campaign, "30d", "/", ".atiyehiraniancf.com");

if (utm_term)
  cookies.set("utm_term", utm_term, "30d", "/", ".atiyehiraniancf.com");

if (utm_content)
  cookies.set("utm_content", utm_content, "30d", "/", ".atiyehiraniancf.com");

if (referred_from)
  cookies.set(
    "referred_from",
    referred_from,
    "30d",
    "/",
    ".atiyehiraniancf.com"
  );

router.beforeEach((to, from, next) => {
  const redirectPaths = [
    "/project",
    "/projects",
    "/atiya",
    "/home",
    "/social",
    "/partnership",
    "/financing",
  ];

  if (redirectPaths.includes(to.path.toLowerCase())) {
    window.location.href = `https://atiyehiraniancf.com${to.fullPath}`;
    return;
  }

  next();
});

export default router;
